import axios from "axios";

/**
 * Obtiene el código de país desde la API
 * @returns {Promise<string>} El código de país (ej: "ES", "MX", etc.)
 */
export const getCountryCode = async (): Promise<string> => {
  try {
    const response = await axios.get("https://edelvivesdigital.com/i2c/api/testkey");
    const countryCodeFromResponse = response.data.data.request_headers["X-Client-Geo-Region"];
    
    // Solo mostrar en desarrollo
    if (process.env.NODE_ENV === "development") {
      console.log("countryCode: " + countryCodeFromResponse);
    }
    
    return countryCodeFromResponse;
  } catch (error) {
    console.error("Error getting country code:", error);
    return "ES"; // Fallback a España
  }
}; 